export interface IQueryParam {
  key: string;
  value: string | number;
}

/**
 * Adds query parameters to the given url.
 * @param url           The url.
 * @param queryParams   A collection of query parameters to add to the url.
 * 
 * @returns A new url containing the query parameters.
 */
export const addQueryParameters = (url: string, queryParams: IQueryParam[]) => {
  if (!url || !queryParams || !queryParams.length) {
    return url;
  }

  // Support existing query parameters
  const splittedUrl = url.split('?');
  const usp = new URLSearchParams(splittedUrl[1]);

  queryParams.forEach((queryParam) => {
    usp.set(queryParam.key, (queryParam.value || '').toString());
  });

  const uspString = usp.toString();

  return `${splittedUrl[0]}?${uspString}`;
};

/**
  * Replaces the value of a url parameter with a new value.
  * @param url     The url to update.
  * @param param   The parameter of the url to update.
  * @param value   The value to update the url parameter with.
  * 
  * @returns      The updated url.
*/
export const updateUrlParameter = (url: string, param: string, value: string): { newUrl: string, hasUpdated: boolean } => {
  const urlObj = new URL(url);
  const urlParams = urlObj.searchParams;

  if(value !== undefined
    && value !== "") {
      urlParams.set(param, value);
    }
    else if(urlParams.has(param)){
      urlParams.delete(param);
    }

  return {
    newUrl: urlObj.toString(),
    hasUpdated: urlObj.toString() != url,
  };
};

/**
 * Updates the current url with the given query parameter.
 * @param param   The parameter of the url to update.
 * @param value   The value to update the url parameter with.
 */
export const updateCurrentUrlParameter = (param: string, value: string) => {
  const { newUrl, hasUpdated } = updateUrlParameter(window.location.href, param, value);
  if (hasUpdated) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};


/**
 * Updates the url based on a set of checks for relative urls
 * @param url   Url to reformat.
 */
export const reformatUrlRelativePaths = (url: string) => {
  if(url.startsWith('~')) {
    url = url.replace('~', '');
  }
 
  if(!url.startsWith('/') && !url.startsWith('http') && url !== '') {
    return `/${url}`;
  }

  return url;
};